<template>
  <v-card>
    <v-card-text>
      <h3>Density</h3>
      <convert-box></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'gram / cubic centimeter (g/cm³)',
          val: 1
        },
        {
          text: 'gram / cubic decimeter',
          val: 1000
        },
        {
          text: 'gram / cubic meter (g/m³)',
          val: 1000000
        },
        {
          text: 'gram / liter',
          val: 1000
        },
        {
          text: 'gram / milliliter',
          val: 1
        },
        {
          text: 'megagram / cubic centimeter',
          val: 0.00001
        },
        {
          text: 'megagram / cubic meter',
          val: 1
        },
        {
          text: 'megagram / liter',
          val: 0.001
        },
        {
          text: 'megagram / milliliter',
          val: 0.00001
        },
        {
          text: 'milligram / cubic centimeter (mg/cm³)',
          val: 1000
        },
        {
          text: 'milligram / cubic decimeter',
          val: 1000000
        },
        {
          text: 'milligram / cubic meter (mg/m³)',
          val: 1000000000
        },
        {
          text: 'milligram / liter',
          val: 1000000
        },
        {
          text: 'milligram / milliliter',
          val: 1000
        },
        {
          text: 'kilogram / cubic centimeter (kg/cm³)',
          val: 0.001
        },
        {
          text: 'kilogram / cubic decimeter',
          val: 1
        },
        {
          text: 'kilogram / cubic meter (kg/m³)',
          val: 1000
        },
        {
          text: 'kilogram / liter',
          val: 1
        },
        {
          text: 'kilogram / milliliter',
          val: 0.001
        },
        {
          text: 'ounce / cubic foot',
          val: 998.84737348
        },
        {
          text: 'ounce / cubic inch',
          val: 0.57803667444
        },
        {
          text: 'ounce / cubic yard',
          val: 26968.879083
        },
        {
          text: 'ounce / gallon (U.K.)(oz/gal)',
          val: 160.35860568
        },
        {
          text: 'ounce / gallon (U.S.)(oz/gal)',
          val: 133.5264718
        },
        {
          text: 'pound / circular mil foot',
          val: 340.4917061
        },
        {
          text: 'pound / cubic foot (lb/ft³)',
          val: 62.427960841
        },
        {
          text: 'pound / cubic inch (lb/in³)',
          val: 0.036127292153
        },
        {
          text: 'pound / cubic yard',
          val: 1685.5549427
        },
        {
          text: 'pound / gallon (U.K.)(lb/gal)',
          val: 10.022412855
        },
        {
          text: 'pound / gallon (U.S.)(lb/gal)',
          val: 8.3454044873
        },
        {
          text: 'grain / cubic foot',
          val: 436995.72588
        },
        {
          text: 'grain / cubic inch',
          val: 252.89104507
        },
        {
          text: 'grain / cubic yard',
          val: 11798884.599
        },
        {
          text: 'grain / gallon (U.K.)',
          val: 70156.889986
        },
        {
          text: 'grain / gallon (U.S.)',
          val: 58417.831411
        },
        {
          text: 'tonne / cubic centimeter',
          val: 0.00001
        },
        {
          text: 'tonne / cubic decimeter',
          val: 0.001
        },
        {
          text: 'tonne / cubic meter',
          val: 1
        },
        {
          text: 'tonne / liter',
          val: 0.001
        },
        {
          text: 'tonne / milliliter',
          val: 0.00001
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// density.vue?0bb09917